import React, { FC, useState } from 'react'
import './RegisterPasswordForm.scss'
import RegisterWrapperCard from '../RegisterWrapperCard/RegisterWrapperCard'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import FormTextField from 'app_components/commons/FormTextField/FormTextField'
import { useForm } from 'react-hook-form'
import { IRegisterDataForm } from 'app_types/register/registerTypes'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import { IconButton, InputAdornment } from '@material-ui/core'
import { MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md'
import RegisterTermsAndConditions from '../RegisterTermsAndConditions/RegisterTermsAndConditions'
import CheckBoxComponent from 'app_components/commons/checkBox/containers/checkBoxComponent'

interface IRegisterPasswordFormProps {
  onSubmit: (formData: IRegisterDataForm) => void
  onBack: () => void
  isLoading?: boolean
}

const RegisterPasswordForm: FC<IRegisterPasswordFormProps> = ({ onSubmit, onBack, isLoading }) => {
  const { control, errors, watch, handleSubmit } = useForm<IRegisterDataForm>()
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false)
  const [showTermsAndConditionsState, setShowTermsAndConditionsState] = useState(false)
  const [termsAndConditionsCheckedState, setTermsAndConditionsCheckedState]= useState(false)


  const acceptTermsAndConditions = () => {
    setTermsAndConditionsCheckedState(true)
    setShowTermsAndConditionsState(false)

  }
  const termsAndConditionsChecked = () => {
    setTermsAndConditionsCheckedState(true)

    if(termsAndConditionsCheckedState===true) {
      setTermsAndConditionsCheckedState(false)
    } else {
      setTermsAndConditionsCheckedState(true)
    }
  }

  const hideTermsAndConditions = () => {
    setShowTermsAndConditionsState(false)
  }

  const showTermsAndConditions = () => {
    setShowTermsAndConditionsState (true)
  }


  if (showTermsAndConditionsState===true) {
    return (
      <RegisterTermsAndConditions hideTermsAndConditions={hideTermsAndConditions} acceptTermsAndConditions={acceptTermsAndConditions}/>
    )
  }

  return (
    <RegisterWrapperCard title='Crea una contraseña'>
      <form onSubmit={handleSubmit(onSubmit)} className="register-password-form--layout">
        <TextComponent fontSize={18} fontWeight={400}>
          Puedes usar letras, números y símbolos combinados
        </TextComponent>
        <div className="register-password-form--fields">
          <FormTextField
            control={control}
            id='password'
            error={errors.password}
            label="Contraseña"
            required
            type={isPasswordVisible ? 'string' : 'password'}
            endAdornment={(
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                  edge="end"
                >
                  {isPasswordVisible ? <MdOutlineVisibility /> : <MdOutlineVisibilityOff />}
                </IconButton>
              </InputAdornment>
            )}
          />
          <FormTextField
            control={control}
            id='confirmPassword'
            error={errors.confirmPassword}
            label="Confirmar contraseña"
            validate={(value) => {
              if (watch('password') !== value) {
                return "Las contraseñas no coinciden"
              }
            }}


            required
            type={isPasswordVisible ? 'string' : 'password'}
            endAdornment={(
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                  edge="end"
                >
                  {isPasswordVisible ? <MdOutlineVisibility /> : <MdOutlineVisibilityOff />}
                </IconButton>
              </InputAdornment>

            )}
          />
          <div className='register-password-form--terms-and-conditions'>
            <CheckBoxComponent checked={termsAndConditionsCheckedState} onClick={termsAndConditionsChecked}/>
            <TextComponent fontSize={18} fontWeight={400}>
              He leído y acepto los <span onClick={showTermsAndConditions} className='register-password-form--security-politics'>Términos de uso y Políticas de seguridad</span>
            </TextComponent>
          </div>
        </div>
        <div className="register-password-form--actions">
          <ButtonComponent
            border='1px solid var(--secondary)'
            color='var(--secondary)'
            textTransform='initial'
            paddingTop={11}
            paddingBottom={11}
            fontSize={18}
            onClick={onBack}
            disabled={isLoading}
          >
            Atras
          </ButtonComponent>
          <ButtonComponent
            variant='secondary'
            textTransform='initial'
            paddingTop={12}
            paddingBottom={12}
            fontSize={18}
            type='submit'
            loading={isLoading}
            disabled={termsAndConditionsCheckedState===false}

          >
            Crear cuenta
          </ButtonComponent>
        </div>
      </form>
    </RegisterWrapperCard>
  )
}

export default RegisterPasswordForm
